const TYPES = {
    GET_OAUTH_LINK: 'GET_OAUTH_LINK',
    GET_OAUTH_LINK_COMPLETE: 'GET_OAUTH_LINK_COMPLETE',
    GET_OAUTH_LINK_FAILED: 'GET_OAUTH_LINK_FAILED',

    GET_OAUTH: 'GET_OAUTH',
    GET_OAUTH_COMPLETE: 'GET_OAUTH_COMPLETE',
    GET_OAUTH_FAILED: 'GET_OAUTH_FAILED',

    RESET_OAUTH: 'RESET_OAUTH'
};

export default {
    TYPES,

    getOAuth: payload => ({
        type: TYPES.GET_OAUTH,
        payload
    }),

    getOAuthSuccess: payload => ({
        type: TYPES.GET_OAUTH_COMPLETE,
        payload
    }),

    getOAuthFailed: error => ({
        type: TYPES.GET_OAUTH_FAILED,
        payload: {error}
    }),

    getOAuthLink: payload => ({
        type: TYPES.GET_OAUTH_LINK,
        payload
    }),

    getOAuthLinkSuccess: payload => ({
        type: TYPES.GET_OAUTH_LINK_COMPLETE,
        payload
    }),

    getOAuthLinkFailed: error => ({
        type: TYPES.GET_OAUTH_LINK_FAILED,
        payload: {error}
    }),

    resetOAuth: payload => ({
        type: TYPES.RESET_OAUTH,
        payload
    })
};
